<template>
  <div>
    <BCard>
      <b-row class="justify-content-between mb-[24px]">
        <b-col
          cols="auto"
          class="flex items-center"
        >
          <h4><strong class="text-black text-2xl">Grup Kontak</strong></h4>
        </b-col>
      </b-row>
      <b-row class="justify-content-between mb-[24px]">
        <BCol
          class="mb-[5px] text-center"
          md="3"
        >
          <BInputGroup class="input-group-merge">
            <BInputGroupPrepend is-text>
              <feather-icon icon="SearchIcon" />
            </BInputGroupPrepend>
            <BFormInput
              v-model="search"
              size="md"
              placeholder="Cari berdasarkan Nama grup"
              style="padding: 8px 1rem 8px 0px"
              @input="searchData"
            />
          </BInputGroup>
        </BCol>
        <BCol
          class="mb-[5px] text-center"
          md="auto"
        >
          <b-dropdown
            id="dropdown-right"
            right
            text="+ Tambah"
            variant="primary"
            class="w-100"
          >
            <b-dropdown-item
              @click="checkConnectionGoogle"
            >
              <div class="flex items-center gap-[14px] item-list">
                <span>+</span>
                <span>Import dari Google</span>
                <img
                  width="20"
                  src="https://storage.googleapis.com/komerce/assets/LP-Komchat/google-icon.svg"
                  alt="icon google"
                >
              </div>
            </b-dropdown-item>
            <b-dropdown-item
              @click="importFromKomship"
            >
              <div class="flex items-center gap-[14px] item-list">
                <span>+</span>
                <span>Import dari Komship</span>
                <img
                  src="https://storage.googleapis.com/komerce/assets/LP-Komerce/komship.svg"
                  alt="icon komship"
                >
              </div>
            </b-dropdown-item>
            <b-dropdown-item
              @click="importFromKomchatAI"
            >
              <div class="flex items-center gap-[14px] item-list">
                <span>+</span>
                <span>Import dari Komchat AI</span>
                <img
                  width="30"
                  height="30"
                  src="https://storage.googleapis.com/komerce/assets/LP-Komerce/komchat.svg"
                  alt="icon komchat"
                >
              </div>
            </b-dropdown-item>
            <b-dropdown-item
              @click="importFromMeta"
            >
              <div class="flex items-center gap-[14px] item-list">
                <span>+</span>
                <span>Import dari Meta</span>
                <img
                  width="25"
                  height="25"
                  src="https://storage.googleapis.com/komerce/LP-Advertiser/icons-meta.svg"
                  alt="icon meta"
                >
              </div>
            </b-dropdown-item>
            <b-dropdown-item @click="createManual">
              <div class="flex items-center gap-[14px] item-list">
                <span>+</span>
                <span>Buat Grup Kontak</span>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </BCol>
      </b-row>
      <BOverlay
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        rounded="sm"
      >
        <BTable
          id="table-grup"
          ref="table-group-scroll"
          :items="items"
          :fields="fields"
          show-empty
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          class="table-grup"
          sticky-header="500px"
          hover
          :select-mode="selectMode"
          @row-clicked="handleToDetailFromTable"
          @scroll.native="handleScroll"
        >

          <template #cell(name)="data">
            <div class="min-w-[140px] flex gap-2 items-center text-[#222]">
              <img
                v-if="data.item.created_from !== 'manual'"
                :src="linkImport[data.item.created_from]"
                :alt="`icon ${data.item.created_from}`"
              >
              <span class="text-sm text-[#828282]">
                {{ data.item.name }}
              </span>
            </div>
          </template>
          <template #cell(createdDate)="data">
            <div class="min-w-[140px] text-[#222]">
              <span class="d-flex">
                {{ data.item.createdDate }}
              </span>
              <span class="text-sm text-[#828282]">
                {{ data.item.createdTime }} WIB
              </span>
            </div>
          </template>
          <template #cell(totalContact)="data">
            <div class="min-w-[140px] flex items-center text-[#222]">
              <div
                v-if="data.item.import_progress"
                class="w-full flex items-center gap-1 justify-between"
              >
                <div class="w-[90%]">
                  <b-progress
                    height="11px"
                    variant="success"
                    :max="data.item.import_progress.contact_total"
                    :value="data.item.import_progress.contact_success"
                  />
                </div>
                <div class="text-sm">
                  {{ `${Math.round(data.item.import_progress.percentage)}%` }}
                </div>
              </div>
              <div
                v-else
                class=" justify-center items-center text-start flex"
              >
                {{ data.item.total_contact }}
              </div>
            </div>
          </template>

          <template #cell(action)="data">
            <div class="d-flex align-items-center gap-[15px]">
              <b-button
                size="sm"
                class="p-0"
                variant="light"
                style="background-color: transparent; border: none"
                @click="handleToDetailFromTable(data.item); $event.stopPropagation()"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/eye.svg"
                  class="max-w-[25px]"
                >
              </b-button>
              <b-button
                size="sm"
                class="p-0"
                variant="light"
                style="background-color: transparent; border: none"
                @click="editData(data.item); $event.stopPropagation()"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/edit.svg"
                  class="max-w-[25px]"
                >
              </b-button>
              <b-button
                size="sm"
                class="p-0"
                variant="light"
                style="background-color: transparent; border: none"
                @click="deleteData(data.item); $event.stopPropagation()"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/trash.svg"
                  class="max-w-[25px]"
                >
              </b-button>
            </div>
          </template>
        </BTable>
      </BOverlay>
      <BRow class="mt-1">
        <BCol
          cols="12"
          class="d-flex justify-content-between"
        >
          <div class="d-flex justify-content-center align-items-center gap-[16px]">
            <strong class="text-[#333]"> Total Grup Kontak </strong>
            <strong class="text-[#F95031]">{{ items.length || 0 }}</strong>
          </div>
        </BCol>
      </BRow>
    </BCard>
    <ModalDelete
      :id="dataDeleteGrupId"
      :get-all-kontak="getAllKontak"
    />
    <ModalEdit
      :id="dataEditGrupId"
      :name="dataEditGrupName"
      :get-all-kontak="getAllKontak"
    />
    <ModalCreate
      :data="dataCreateGrup"
      :get-all-kontak="getAllKontak"
    />
  </div>

</template>
<script>
import {
  BCol,
  BRow,
  BCard,
  BOverlay,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ModalDelete from './modal/ModalDeleteFolder.vue'
import ModalEdit from './modal/ModalEditGrup.vue'
import ModalCreate from './modal/ModalCreateGrup.vue'
import { apiSignInGoogle, apiSignInGoogleVerify, apiCheckConnectionGoogle } from './Broadcast/service/api.groupContact.service'
import { linkImport } from './groupContact/config'

export default {
  components: {
    BCol,
    BRow,
    BCard,
    BOverlay,
    ModalDelete,
    ModalEdit,
    ModalCreate,
  },
  data() {
    return {
      loading: false,
      isLoading: false,
      selectMode: 'single',
      search: '',
      dataDeleteGrupId: 0,
      dataEditGrupName: '',
      dataEditGrupId: 0,
      dataCreateGrup: '',
      fields: [
        {
          key: 'name',
          label: 'Nama',
          thClass: 'font-bold text-black',
          class: 'align-middle text-black',
          sortable: true,
        },
        {
          key: 'createdDate',
          label: 'Tanggal Ditambahkan',
          thClass: 'font-bold',
          class: 'align-middle text-black',
        },
        {
          key: 'totalContact',
          label: 'Jumlah Kontak',
          thClass: 'font-bold',
          class: 'align-middle text-black',
        },
        {
          key: 'action',
          label: 'Aksi',
          thClass: 'font-bold',
          class: 'align-middle text-black',
        },
      ],
      items: [],
      dateTime: [],
      cursor: 0,
      limit: 20,
      lastData: false,
      anyImportProcess: false,
      progressInterval: null,
      isKomshipUser: this.$store.state.dashboard.profile.is_komship === 1,
      dialogUrl: '',
      token: '',
      linkImport,
    }
  },
  mounted() {
    this.getAllKontak()
  },
  beforeDestroy() {
    this.stopProgressTracking()
  },
  methods: {
    async getAllKontak() {
      this.isLoading = !this.anyImportProcess
      const params = {
        search: this.search,
        limit: this.limit,
        cursor: 0,
      }

      try {
        const res = await this.$http_new.get('/komchat-api/api/v1/group-contact/list', { params })
        const { data, meta } = res?.data

        this.items = data?.map(item => {
          const createdAtDate = new Date(item.created_at)
          const createdDate = createdAtDate.toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })
          const createdTime = createdAtDate.toLocaleTimeString('id-ID', { hour12: false, hour: '2-digit', minute: '2-digit' })

          return {
            ...item,
            createdDate,
            createdTime,
          }
        })
        if (data.length > 0) this.findProgressImportKomship(data[0])
        this.findProgressImport(data)
        this.cursor = meta?.pagination.next_cursor

        this.lastData = !!(data.length < this.limit || this.cursor === undefined)
      } catch {
        this.$toast_error({ message: 'Gagal mengambil data grup kontak' })
      } finally {
        this.isLoading = false
      }
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (
        scrollTop + clientHeight >= scrollHeight - 1
        && !this.loading
        && !this.lastData
      ) {
        this.nextData()
      }
    },
    async nextData() {
      this.isLoading = true
      const params = {
        search: this.search,
        limit: this.limit,
        cursor: this.cursor,
      }

      try {
        const res = await this.$http_new.get('/komchat-api/api/v1/group-contact/list', { params })
        const { data, meta } = res.data

        const newItems = data?.map(item => {
          const createdAtDate = new Date(item.created_at)
          const createdDate = createdAtDate.toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' })
          const createdTime = createdAtDate.toLocaleTimeString('id-ID', { hour12: false, hour: '2-digit', minute: '2-digit' })

          return {
            ...item,
            createdDate,
            createdTime,
          }
        })

        this.findProgressImport(data)
        this.items.push(...newItems)
        this.cursor = meta.pagination.next_cursor
        this.lastData = data.length < this.limit || this.cursor === undefined
      } catch {
        this.$toast_error({ message: 'Gagal mengambil data grup kontak' })
      } finally {
        this.isLoading = false
      }
    },
    searchData: _.debounce(function search() {
      this.getAllKontak()
    }, 1000),
    findProgressImport(data) {
      const dataProcess = data.filter(item => {
        const process = item.import_progress
        return process
      })
      this.anyImportProcess = dataProcess.length > 0
      if (this.anyImportProcess) {
        this.startProgressTracking(10000)
      } else {
        this.stopProgressTracking()
      }
    },
    findProgressImportKomship(data) {
      const onImportContact = this.$route.params?.onImport
      const total = this.$route.params?.total
      const onImport = data.total_contact !== total && data.created_from === 'komship'
      if (onImport && onImportContact) {
        this.startProgressTracking(4000)
      } else {
        this.stopProgressTracking()
      }
    },
    startProgressTracking(interval) {
      if (!this.progressInterval) {
        this.progressInterval = setInterval(this.getAllKontak, interval)
      }
    },
    stopProgressTracking() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
        this.progressInterval = null
      }
    },
    editData(dataEdit) {
      this.dataEditGrupId = dataEdit.id
      this.dataEditGrupName = dataEdit.name
      this.$bvModal.show('modal-edit')
    },
    deleteData(dataDelete) {
      this.dataDeleteGrupId = dataDelete.id
      this.$bvModal.show('modal-delete-folder')
    },
    createManual() {
      this.$bvModal.show('modal-create')
    },
    importFromKomship() {
      if (!this.isKomshipUser) {
        window.open('https://komship.id/pendaftaran')
      } else {
        this.$router.push({
          path: '/import-from-komship',
        })
      }
    },
    async importFromGoogle() {
      try {
        const { data } = await apiSignInGoogle()
        this.dialogUrl = data.data.url
        this.openGoogleSignIn()
      } catch (error) {
        this.$toast_error({ message: this.capitalizeWords(error.response.data.meta.message) })
      }
    },
    importFromKomchatAI() {
      this.$router.push({
        path: '/import-from-komchat-ai',
      })
    },
    importFromMeta() {
      this.$router.push({
        path: '/import-from-meta',
      })
    },

    handleToDetailFromTable(data) {
      const dataGroup = JSON.stringify(data)
      this.$router.push({
        name: '/grup-contact/list-contact',
        params: { data: dataGroup },
      })
    },
    async checkConnectionGoogle() {
      try {
        const { data } = await apiCheckConnectionGoogle()
        const isConnect = data.data.is_connect
        if (isConnect) {
          this.token = data.data.token
          this.redirectToListContact()
        } else {
          this.importFromGoogle()
        }
      } catch {
        this.$toast_error('Gagal cek login google')
      }
    },
    openGoogleSignIn() {
      this.authWindow = window.open(this.dialogUrl, 'Google Sign-In', 'width=600,height=700')
      this.pollOAuthData()
    },
    pollOAuthData() {
      const pollingInterval = setInterval(() => {
        try {
          const oauthData = localStorage.getItem('google_oauth_code')
          if (oauthData) {
            const { code } = JSON.parse(oauthData)
            localStorage.removeItem('google_oauth_code')
            clearInterval(pollingInterval)
            this.verifySignInGoogle(code)
          }
          if (this.authWindow.closed) {
            clearInterval(pollingInterval)
          }
        } catch (error) {
          this.$toast_error({ message: this.capitalizeWords(error) })
        }
      }, 1000)
    },
    redirectToListContact() {
      this.$router.push(`/grup-contact/list-contact-google?token=${this.token}`)
    },
    async verifySignInGoogle(code) {
      try {
        const { data } = await apiSignInGoogleVerify(code)
        this.token = data.data.token
        this.redirectToListContact()
      } catch (err) {
        this.$toast_error({ message: 'Verifikasi Gagal, Silahkan coba lagi!' })
      }
    },

  },

}
</script>

<style scoped>
ul li .item-list {
    width: max-content !important;
}
</style>
